import React, { useEffect } from 'react';
import { Check, Warning, X } from "@phosphor-icons/react";
import { useTranslation } from 'react-i18next';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'warning';
  onClose: () => void;
  persistent?: boolean;
  className?: string;
}

const Toast: React.FC<ToastProps> = ({ message, type = 'success', onClose, persistent = false, className = '' }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!persistent) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [onClose, persistent]);

  return (
    <div className={`toast toast-${type} ${className}`.trim()}>
      {type === 'success' ? <Check size={20} /> : <Warning size={20} />}
      <span>{message}</span>
      {persistent && (
        <button 
          onClick={onClose}
          className="toast-close"
          aria-label={t('actions.close', 'Close')}
          style={{
            marginLeft: 'auto',
            background: 'none',
            border: 'none',
            color: 'inherit',
            cursor: 'pointer',
            padding: '0',
            display: 'flex',
            alignItems: 'center',
            opacity: 0.8
          }}
        >
          <X size={18} />
        </button>
      )}
    </div>
  );
};

export default Toast; 